'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.cjs');
var MetaplexError = require('./MetaplexError.cjs');

/** @group Errors */
class ProgramError extends MetaplexError.MetaplexError {
  constructor(message, program, cause, logs) {
    super(message, 'program', `${program.name} [${program.address.toString()}]`, cause);
    _rollupPluginBabelHelpers.defineProperty(this, "name", 'ProgramError');
    this.program = program;
    this.logs = logs;
    if (logs) {
      this.message = this.message + `\nProgram Logs:\n${logs.map(log => '| ' + log).join('\n')}\n`;
    }
  }
}
/** @group Errors */
class ParsedProgramError extends ProgramError {
  constructor(program, cause, logs) {
    const ofCode = cause.code ? ` of code [${cause.code}]` : '';
    const message = `The program [${program.name}] ` + `at address [${program.address.toString()}] ` + `raised an error${ofCode} ` + `that translates to "${cause.message}".`;
    super(message, program, cause, logs);
    _rollupPluginBabelHelpers.defineProperty(this, "name", 'ParsedProgramError');
  }
}

/** @group Errors */
class UnknownProgramError extends ProgramError {
  constructor(program, cause) {
    const ofCode = cause.code ? ` of code [${cause.code}]` : '';
    const message = `The program [${program.name}] ` + `at address [${program.address.toString()}] ` + `raised an error${ofCode} ` + `that is not recognized by the programs registered on the SDK. ` + `Please check the underlying program error below for more details.`;
    super(message, program, cause, cause.logs);
    _rollupPluginBabelHelpers.defineProperty(this, "name", 'UnknownProgramError');
  }
}

exports.ParsedProgramError = ParsedProgramError;
exports.ProgramError = ProgramError;
exports.UnknownProgramError = UnknownProgramError;
//# sourceMappingURL=ProgramError.cjs.map
